<template>
    <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Nom</label>
                    <md-input v-model="document.name" name="name" type="text" required></md-input>
                    <validation-error :errors="apiValidationErrors.name"/>
                </md-field>
            </div>
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Poids</label>
                    <md-input v-model="document.order" name="order" type="number" required></md-input>
                    <validation-error :errors="apiValidationErrors.order"/>
                </md-field>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item md-size-100 mt-4">
                <md-field>
                    <label>Catégorie *</label>
                    <md-select v-model="document.type" name="types" id="types">
                        <template v-for="type in typesList">
                            <md-option v-if="type.parent_id === null" :key="type.id" :value="type.id">{{ type.name }}</md-option>
                            <template v-if="type.children.length > 0">
                                <md-option v-for="child in type.children" :key="child.id" class="doc-type-child" :value="child.id">{{ child.name }}</md-option>
                            </template>
                        </template>
                    </md-select>
                </md-field>
            </div>
            <div class="md-layout-item md-size-100 mt-4">
                <md-field class="md-invalid">
                    <label>Description</label>
                    <md-textarea v-model="document.description" name="description" md-autogrow></md-textarea>
                    <validation-error :errors="apiValidationErrors.description"/>
                </md-field>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-50" v-if="document.url">
                <div class="h-full">
                    <h4 class="mb-1"><b>Fichier actuel</b> (si vous en sélectionnez un autre, celui-ci sera remplacé)
                    </h4>
                    <div class="flex items-center">
                        <div>
                            <md-button class="md-icon-button md-raised md-info"
                                       :href="document.url" target="_blank">
                                <i class="md-icon fa fa-download"/>
                            </md-button>
                            <md-tooltip md-direction="top">Télécharger</md-tooltip>
                        </div>
                        <span class="ml-2">{{ formatFilePath(document.path) }}</span>
                    </div>
                </div>
            </div>
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Fichier</label>
                    <md-file name="file" @change="selectFile"
                             accept=".doc,.docx,.pdf,.xls,.xlsx,.jpg"></md-file>
                    <validation-error marge="ml-2" :errors="apiValidationErrors.file"/>
                </md-field>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "DocumentForm",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    data() {
        return {
            typesList: []
        }
    },
    props: {
        document: {
            type: Object,
            default() {
                return {
                    name: '',
                    type: 0,
                    order: 0,
                    description: '',
                    file: null,
                    path: ''
                }
            }
        },
        errors: Array,
    },
    methods: {
        selectFile(e) {
            this.resetApiValidation();
            const file = e.target.files[0]
            if (file.size > 5242880) {
                this.setApiValidation([{
                    detail: 'Le fichier est trop volumineux. Taille maximale : 5 Mo.',
                    source: { pointer: '/data/attributes/file' }
                }]);
            } else {
                this.document.file = file
            }
        },
        formatFilePath(path = '') {
            return path.slice(5)
        },
        async getDocumentTypes() {
            let { data } = await this.$store.dispatch('documents/getDocumentTypes')
            this.typesList = data
        },
    },
    mounted() {
        this.getDocumentTypes()
    },
    watch: {
        errors: function (newVal, oldVal) {
            this.resetApiValidation();
            if (newVal) {
                this.setApiValidation(newVal);
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-layout-item {
        h4 {
            font-size: .75rem;
        }

        .md-button {
            width: auto;
            margin: 0;
            padding: 5px;
            height: 27px;
            min-width: 27px;
            line-height: 27px;

            .md-icon {
                font-size: .875rem !important;
                min-width: .875rem !important;
                height: .875rem !important;
            }
        }
    }
}
</style>
